export enum NoteCrmConnectionChangeType {
  REPLACE_SAME_TYPE = 'replaceConnectionSameType',
  REPLACE_OTHER_TYPE = 'replaceConnectionOtherType',
  NEW_CONNECTION = 'newConnection',
  DELETE_CONNECTION = 'deleteConnection',
}
